import BenefitCard from "@/components/benefit-card/benefit-card";
import MissionStatus from "@/components/mission-status/mission-status";
import { OverflowComponentProps } from "./overflow-container-types";
import { OverflowedBenefit, OverflowedMission, MissionContainer, BenefitContainer } from "./style-component";
import { Mission } from "@/types/mission/mission-type";
import { Benefit } from "@/types/benefit/benefit-type";
import { EmptyGridMessageContainer } from "../grid-cards/style-component";
import EmojiLookDown from "@/assets/icons/emoji-look-down/emoji-look-down.svg"

const OverflowComponent: React.FC<OverflowComponentProps> = ({ items, isBenefit }) => {

  if (!Array.isArray(items) || items?.length === 0 || !items) {
    return (
      <EmptyGridMessageContainer>
        <img src={EmojiLookDown} alt="" />
        <h3>Está un poco vacío por aquí...</h3>
        <p>Participa en misiones para hacer crecer tu biblioteca.</p>
      </EmptyGridMessageContainer>
    );
  }

  if (isBenefit) {
    return (
      <BenefitContainer $itemCount={items.length}>
        {Array.isArray(items) && items?.slice(0, 4)?.map((item, index) => (
          <OverflowedBenefit key={index} $itemCount={items?.length}>
            <BenefitCard benefit={item as Benefit} expandable={false} />
          </OverflowedBenefit>
        ))}
      </BenefitContainer>
    );
  } else {
    return (
      <MissionContainer $itemCount={items.length}>
        {Array.isArray(items) && items?.slice(0, 3)?.map((item, index) => (
          <OverflowedMission key={index} $itemCount={items?.length}>
            <MissionStatus mission={item as Mission} />
          </OverflowedMission>
        ))}
      </MissionContainer>
    );
  }
};

export default OverflowComponent;
